import { render, staticRenderFns } from "./WalletAdminSummary.vue?vue&type=template&id=c2c0ed60&scoped=true&"
import script from "./WalletAdminSummary.vue?vue&type=script&lang=js&"
export * from "./WalletAdminSummary.vue?vue&type=script&lang=js&"
import style0 from "./WalletAdminSummary.vue?vue&type=style&index=0&id=c2c0ed60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0ed60",
  null
  
)

export default component.exports